<template>
    <div class="container">
        <h1>Đề xuất khách hàng</h1>

        <b-button @click="suggestByAllRules" variant="primary">Đề xuất</b-button>

        <div class="row">
            <div class="col-6">
                <template v-for="rule in rules">
                    <b-form-checkbox v-model="rule.selected" v-bind:key="rule.id" v-if="rule.valid">{{rule.label}}</b-form-checkbox>
                </template>
            </div>
        </div>
        
        <b-alert :show="message!=''">
            <p v-html="message"></p>
        </b-alert>
        <hr/>

        <b-spinner v-if="isLoadingList"></b-spinner>
        <div v-if="!isLoadingList">
            <b-table striped 
                sticky-header
                head-variant="light"
                :items="filteredClientList"
                :fields="tableFormat.fields"
                :sort-by.sync="tableFormat.sortBy"
                :sort-desc.sync="tableFormat.sortDesc"
                :perPage="tableFormat.perPage"
                :currentPage="tableFormat.currentPage"
                sort-icon-left
                responsive="sm"
                >
                    <!-- <template slot="top-row" slot-scope="{ fields }">
                        <td v-for="field in fields" :key="field.key">
                        <input v-model="tableFormat.filters[field.key]" :placeholder="field.label">
                        </td>
                    </template> -->

                    <template #cell(fullname)="data">
                        <a href="#" @click="viewClient(data.item.id)">{{data.item.fullname}} </a>
                        <b-icon icon="eye" @click="previewClient(data.item.id)" font-scale="1.8" class="m-1 clickable"></b-icon>
                    </template>

                    <template #cell(matching)="data">
                        {{data.item.matchingLabel.join(",")}}
                    </template>
                </b-table>

            <b-pagination
                v-model="tableFormat.currentPage"
                :total-rows="tableFormat.totalRow"
                :per-page="10"
                aria-controls="my-table"
                ></b-pagination>

            <span>Số lượng: {{tableFormat.totalRow}}</span>
        </div>

        <b-modal v-model="previewModalShow" hide-footer title="Xem Nhanh">

            <generic-detail-view
                :rootPath="'/v2/' + modalInfo.module"
                :forms="modalInfo.forms"
                :columns="modalInfo.columns"
                :table_name="modalInfo.table_name"
                :service="modalInfo.service"
                :modalClientId="clientId"
                layout="grid"
                >
                
            </generic-detail-view>

            <hr/>
            <h1>Trao đổi</h1>
            <client-chat-logs :clientId="clientId"></client-chat-logs>

        </b-modal>
    </div>
</template>

<script>
import VueBootstrapTypeahead from 'vue-typeahead-bootstrap'

import GenericDetailView from '@/views/base/GenericDetailView'

import ClientTableMeta from '@/module-client/ClientTableMeta'
import ClientService from '@/module-client/ClientService'
import ClientChatLogs from '@/module-chat/ClientChatLogs'

import ProductService from '@/services/productService'
import Constants from '@/constants'

import Firebase from '@/services/firebase'
import moment from 'moment';
import axios from 'axios';

export default {
  name: 'ClientSuggestion',
  components: {
      GenericDetailView,
      'client-chat-logs': ClientChatLogs
  },
  computed () {
      filtered: () => {
            const filtered = this.filteredClientList.filter(item => {
                return Object.keys(this.tableFormat.filters).every(key =>
                    String(item[key]).includes(this.tableFormat.filters[key]))
            })
            return filtered.length > 0 ? filtered : [{
                fullname: '',
                phone: '',
                address: '',
                needs_price_range: '',
                sale: '',
                status: '',
                matching: ''
            }]
        }
  },
  data () {
    return {
        tableFormat: {
            sortBy: '',
            sortDesc: false,
            perPage: 10,
            filters: {
                fullname: '',
                phone: '',
                address: '',
                needs_price_range: '',
                sale: '',
                status: ''
            },
            fields: [
                { key: 'fullname', label: 'Họ tên' },
                { key: 'phone',  label: 'SĐT' },
                { key: 'address', label: 'Nơi cư trú' },
                { key: 'needs_price_range', label: 'Tầm giá' },
                { key: 'sale', sortable: true, label: 'Người phụ trách' },
                { key: 'status', sortable: true, label: 'Mối quan hệ' },
                // { key: 'street', sortable: true },
                { key: 'matching'}
            ],
            currentPage: 0,
            totalRow: 0
        },
        rules: [],
        clientList: [],
        filteredClientList: [],
        clientMap: {},
        clientMatchingList: [],
        productInfo: {},
        message: '',
        previewModalShow: false,
        modalInfo: {
          module: 'clients',
          forms: ClientTableMeta.preview,
          columns: ClientTableMeta.columns,
          table_name: ClientTableMeta.main_table_name,
          service: new ClientService()
        },
        clientId: null,
        
        isLoadingList: false,
        clientService: null
    }
  },
  
  methods: {
      clientLabel(s) {
          return s.fullname + '-' + s.phone
      },

      formatDateTime(v) {
          return moment(v).format('DD/MM/YYYY hh:mm:ss')
      },

      formatDate(v) {
          return moment(v).format('DD/MM/YYYY')
      },

      viewClient(id) {
          let routeData = this.$router.resolve({path: `/v2/clients/${id}/view`, query: {  }});
            window.open(routeData.href, '_blank');
      },

      previewClient(id) {
          this.previewModalShow = true;
          this.clientId = id;
      },


        populateRuleWithProductInfo(product) {
            var rule = {};
            this.rules = [];

            this.rules.push({
                id: 'ward',
                query: `SELECT id FROM realestate.clients_needs_ward WHERE needs_ward='${product.ward}' GROUP BY id`,
                label: `phường ${product.ward}`,
                valid: (product.ward?true:false),
                weight: 10
            });

            this.rules.push({
                id: 'project',
                query: `SELECT id FROM realestate.clients_needs_population WHERE needs_population_area='${product.project}' GROUP BY id`,
                label: `tên dự án ${product.project}`,
                valid: (product.project?true:false),
                weight: 100
            });

            this.rules.push({
                id: 'direction',
                    query: `SELECT id FROM realestate.clients_needs_direction WHERE needs_direction='${product.direction}' GROUP BY id`,
                    label: `hướng  ${product.direction}`,
                valid: (product.direction?true:false),
                weight: 1
            });

            this.rules.push({
                id: 'area',
                query: `SELECT id FROM realestate.clients_needs_area WHERE needs_area_from<=${product.area} and needs_area_to>=${product.area} GROUP BY id`,
                label: `tầm diện tích ${product.area}`,
                valid: (product.area?true:false),
                weight: 1000
            });

            this.rules.push({
                id: 'price',
                query: `SELECT id FROM realestate.clients_needs_price WHERE needs_price_from<=${product.price} and needs_price_to>=${product.price} GROUP BY id`,
                label: `tầm giá ${product.price}`,
                valid: (product.price?true:false),
                weight: 10000
            });

            for(var i=0; i< this.rules.length; i++) {
                this.rules[i].selected = false;
            }
        },

        async loadProductInfo() {
            var productService = new ProductService()
            this.productInfo = await productService.getDetail(this.productId);

            console.log('product info: ', this.productInfo);
            this.populateRuleWithProductInfo(this.productInfo);
        },

        updateClientListMatchingRules(clients, rule) {
            rule.clients = clients;

            for(var i=0; i<clients.length; i++) {
                var c = clients[i];

                if(this.clientMap[c.id]) {
                    if(!this.clientMap[c.id].matching) {
                        this.clientMap[c.id].matching = [];
                        this.clientMap[c.id].matchingLabel = [];
                        this.clientMap[c.id].matchingWeight = 0;
                    }

                    this.clientMap[c.id].matching.push(rule);
                    this.clientMap[c.id].matchingLabel.push(rule.label);
                    this.clientMap[c.id].matchingWeight += rule.weight;
                }

                // for(var j=0; j<this.clientList.length; j++) {
                //     if(clients[i].id === this.clientList[j].id) {
                //         if(!this.clientList[j].matching){
                //             this.clientList[j].matching = []
                //         }
                        
                //         this.clientList[j].matching.push(rule.label);

                //         console.log('found ', this.clientList[j]);
                        
                //     }
                // }
            }
        },

      async suggestByRule(rule) {
          console.log('suggest by rule ', rule);
          var query = rule.query;
          query = encodeURI(query);

        var url = Constants.HOST_URL + 'runSelectQuery?query=' + query;

        try {
            var response = await axios.get(url);

            console.log('suggest by rule > result ', response.data);
            this.updateClientListMatchingRules(response.data, rule);
        } 
        catch(err) {
            alert('Có lỗi khi tải dữ liệu.');
            console.log(err);
        }
      },

      async suggestByAllRules() {
          this.isLoadingList = true;
          this.message = 'Bắt đầu tìm kiếm...<br/>';
          // load full client list

          this.clientList = [];
          this.clientMap = {};

          await this.loadClientList();
          this.message += 'Duyệt danh sách khách hàng -> ';
          this.message += ` tổng cộng có ${this.clientList.length} khách hàng <br/>`;

          // load each rule, each rule should produce one client list
          var isPriceRuleSelected = false;
          for(var i=0; i<this.rules.length; i++) {
            this.message += 'Đang tìm kiếm theo ' + this.rules[i].label; 
            if(this.rules[i].valid && this.rules[i].selected)
            {
                await this.suggestByRule(this.rules[i]);
                this.message += ` -> kết thúc, tìm thấy ${this.rules[i].clients.length} khách hàng phù hợp`;
            }
            else if(!this.rules[i].valid) {
                this.message += ' -> bỏ qua do sản phẩm không có thông tin này.'
            } else {
                this.message += ' -> bỏ qua.';
            }

            this.message += '<br/>';

            if(this.rules[i].id == 'price' && this.rules[i].selected) {
                isPriceRuleSelected = true;
            }
          }

          this.message += 'Tổng hợp kết quả...<br/>'

            this.filteredClientList = [];
            var tmp = [];
            for(var key in this.clientMap) {
                var shouldKeepThisResult = this.clientMap[key].matching ? true : false;
                
                // only keep this result if the price match. Otherwise we shouldn't keep it
                if(isPriceRuleSelected) {
                    shouldKeepThisResult = shouldKeepThisResult && (this.clientMap[key].matchingWeight >= 10000);
                }

                if(shouldKeepThisResult) {
                    // by 

                    tmp.push(this.clientMap[key]);
                }
                
            }

            // sort the client list
            this.message += 'Sắp xếp kết quả theo thứ tự ưu tiên...<br/>'
            
            this.filteredClientList = tmp.sort(function(clientA, clientB) {
                console.log('sort ', clientA, clientB);
                if(clientA.matching.lenght > clientB.matching.lenght) {
                    // console.log('-> ', clientA.matching.lenght - clientB.matching.lenght)
                    return -1*(clientA.matching.lenght - clientB.matching.lenght)
                }
                else if(clientA.matching.lenght < clientB.matching.lenght) {
                    // console.log('-> ', clientA.matching.lenght - clientB.matching.lenght)
                    return -1*(clientA.matching.lenght - clientB.matching.lenght)
                }
                else {
                    // compare by weight
                    // console.log('-> weightDiff: ', clientA.matchingWeight - clientB.matchingWeight)
                    return -1*(clientA.matchingWeight - clientB.matchingWeight)
                }
            })

            // this.filteredClientList = tmp;

            this.tableFormat.totalRow = this.filteredClientList.length;

          this.message += 'Đã hoàn tất.<br/>'

          this.isLoadingList = false;
      },

    async loadClientList () {
        var service = new ClientService();
        var results = await service.listSimple();
        this.clientList = results;

        // convert clientList into clientMap
        for(var i=0;i<this.clientList.length; i++) {
            this.clientMap[this.clientList[i].id] = this.clientList[i];
        }
    },

  },
  props: ['productId'],
  mounted () {
     this.loadProductInfo();
  }
}
</script>

<style scoped>
</style>
